import { RuleSetDto, RuleSetFormState } from 'Core-utils/types/RuleSetsConfig.types';

export const emptyRuleSetForm = (): RuleSetFormState => ({
    name: '',
    description: '',
    cid: '',
    // eslint-disable-next-line camelcase
    is_default: false,
});

export const formFromRuleSet = (rs: RuleSetDto): RuleSetFormState => ({
    name: rs.name ?? '',
    description: rs.description ?? '',
    cid: rs.cid ?? '',
    // eslint-disable-next-line camelcase
    is_default: rs.is_default,
});
